import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { logException } from "@wss/error-tracking";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@clarkinc/zest-design-system/ui";
import { storageFactory } from "storage-factory";
import { requestIsInEuropeanUnion } from "./requests";
const dataPolicyKey = "data-policy-seen";
const outsideOfEuropeanUnionKey = "outside-of-european-union";
export function GdprBannerModal() {
  const local = storageFactory(() => window.localStorage);
  const session = storageFactory(() => window.sessionStorage);
  const [isOpen, setIsOpen] = useState(false);
  function onClose() {
    local.setItem(dataPolicyKey, "true");
    setIsOpen(false);
  }
  useEffect(function initIpCheck() {
    const controller = new AbortController();
    async function handleCheckIp() {
      const result = await requestIsInEuropeanUnion({
        signal: controller.signal
      });
      if (result.isError) return logException(result.error);
      if (!result.value.returnFlag) {
        return session.setItem(outsideOfEuropeanUnionKey, "true");
      }
      return setIsOpen(true);
    }
    if (session.getItem(outsideOfEuropeanUnionKey)) return;
    if (local.getItem(dataPolicyKey)) return;
    handleCheckIp();
    return function cleanupIpCheck() {
      controller.abort();
    };
  }, [session, local]);
  return <Modal open={isOpen} theme="wss" data-sentry-element="Modal" data-sentry-component="GdprBannerModal" data-sentry-source-file="index.tsx">
      <ModalHeader closeButtonProps={{
      disabled: true
    }} data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        User Data Policy
      </ModalHeader>
      <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="index.tsx">
        We would like to use cookies and identify general user data to give you
        a better experience on our website. Using cookies and identifying data
        such as IP address and the type and version of your browser help us
        improve our website&apos;s navigation and provide more personalized
        services to you. To find out more, see our{" "}
        <a href="/policies.html#Privacy_Policy" className="underline">
          Privacy Policy
        </a>
        .
      </ModalBody>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <Button type="button" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          Accept
        </Button>
      </ModalFooter>
    </Modal>;
}
export default function GdprBanner(): JSX.Element {
  const gdprBannerMount = document.getElementById("gdprBannerMount");
  return <>{ReactDOM.render(<GdprBannerModal />, gdprBannerMount)}</>;
}